import Consents from "@/models/Consents";
import axios, { AxiosResponse } from "axios";

let instance = null;

class RGPDService {
    async getConsents(qrcodeId: string): Promise<Consents> {
        const response: AxiosResponse<{ consents: Consents; success: boolean }> = await axios.get(
            "consents/" + qrcodeId
        );

        if (response.status === 200 && response.data.success) {
            return response.data.consents;
        } else {
            return null;
        }
    }

    async addConsents(
        qrcodeId: string,
        termsAndConditionsConsent: boolean,
        shareEmailConsent: boolean
    ): Promise<Consents> {
        return await axios.post("consents/" + qrcodeId, {
            termsAndConditionsConsent,
            shareEmailConsent
        });
    }
}

function getInstance(): RGPDService {
    if (!instance) {
        instance = new RGPDService();
    }

    return instance;
}

export default getInstance;
